import ReactDOM from 'react-dom';

// Patch for ReactQuill compatibility with React 19
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = (component) => {
    if (component?.nodeType === 1) {
      return component;
    }
    if (component?._reactInternalFiber?.stateNode) {
      return component._reactInternalFiber.stateNode;
    }
    if (component?._reactInternals?.stateNode) {
      return component._reactInternals.stateNode;
    }
    return null;
  }
}